import { combineReducers } from 'redux';
import { reducer as notificationsReducer } from 'reapop'
// import User from './User';
import Home from './Home'
import SignIn from './User/SignIn'
import SignUp from './User/SignUp'
import Header from './Header'
import App from './App'
import Community from './Community'
import FirstProfRegist from './User/FirstProfRegist'
import UserCircle from './User/CircleList'
import UserMessages from './User/Messages'
import UserProfileEdit from './User/ProfileEdit'
import CreditCard from './User/Credit'
import MyPage from './User/MyPage'
import Search from './Search'
import Post from './Post'
import UserShow from './User/Show'
import UserBank from './User/Bank'
import Location from './Location'

import {routerReducer} from "react-router-redux";


const rootReducer = combineReducers({
  SignIn,
  SignUp,
  Header,
  Home,
  App,
  Community,
  FirstProfRegist,
  UserCircle,
  UserMessages,
  UserProfileEdit,
  CreditCard,
  MyPage,
  Search,
  Post,
  UserShow,
  UserBank,
  Location,
  router: routerReducer,
  notifications: notificationsReducer()
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.jsx